<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-4">
        <div class="card-header">
          <i class="fas fas-align-justify"></i>
          Remedial
        </div>
        <div class="card-body">
          <h4 class="mt-3">Remedial Details</h4>
          <form [formGroup]="remedialForm" (ngSubmit)="submitForm()" class="needs-validation" novalidate>
            <div class="row">
              <div class="col">
                <labeled-display
                  [name]="'Status'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="remedial?.status ?? 'New'"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Appointment Date'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="remedial?.ccrRems?.apptDate | date: 'dd/MM/yy'"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Completed Date'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="remedial?.ccrRems?.completedDate | date: 'dd/MM/yy'"></labeled-display>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <labeled-input
                  [name]="'Name'"
                  [formName]="'name'"
                  [form]="remedialForm"
                  [type]="'text'"
                  [readonly]="!canUpdate"
                  [class]="'form-control'"></labeled-input>
              </div>
              <div class="col">
                <labeled-input
                  [name]="'Park'"
                  [formName]="'park'"
                  [form]="remedialForm"
                  [type]="'text'"
                  [readonly]="!canUpdate"
                  [class]="'form-control'"></labeled-input>
              </div>
              <div class="col">
                <labeled-input
                  [name]="'Plot'"
                  [formName]="'plot'"
                  [form]="remedialForm"
                  [type]="'text'"
                  [readonly]="!canUpdate"
                  [class]="'form-control'"></labeled-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <labeled-input
                  [name]="'Contract Number'"
                  [formName]="'contractNumber'"
                  [form]="remedialForm"
                  [type]="'text'"
                  [class]="'form-control'"></labeled-input>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Serial Number'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="remedial?.serialNumber"></labeled-display>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Installation Date'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="remedial?.installationDate | date: 'dd/MM/yy'"></labeled-display>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="col-form-label d-block">
                  Description
                  <textarea name="Description" class="form-control" [formGroup]="remedialForm"
                            [readonly]="!canUpdate"
                            [formControlName]="'description'" rows="5"></textarea>
                </label>
              </div>
              <div class="col">
                <labeled-display
                  [name]="'Work Completed'"
                  [type]="'text'"
                  [class]="'form-control'"
                  [value]="remedial?.ccrRems?.workDone"></labeled-display>
              </div>
              <div class="col">
                <labeled-input
                  [name]="'Call No'"
                  [formName]="'adminbaseCallNumber'"
                  [form]="remedialForm"
                  [type]="'number'"
                  [readonly]="!canUpdate"
                  [class]="'form-control'"></labeled-input>
              </div>
            </div>
            <h4 class="mt-3">Remedial Rows</h4>
            <div class="row">
              <div class="card-body">
                <table class="table table-striped table-bordered">
                  <thead>
                  <tr>
                    <th>Item</th>
                    <th>Issue</th>
                    <th>Description (Optional)</th>
                    <th>Main Issue</th>
                    <th>Status</th>
                    <th>Feedback</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let row of remedial?.remedialRows; index as i" [formGroupName]="i">
                    <td class="col-2">{{ row.item }}</td>
                    <td class="col-2">{{ row.issue }}</td>
                    <td>{{ row.description }}</td>
                    <td class="col-1">{{ row.mainIssue ? 'Yes' : '' }}</td>
                    <td class="col-1">{{ row.status }}</td>
                    <td>{{ row.reason }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col">
                <h4 class="float-left">Images</h4>
                <button (click)="this.uploadImages()" type="button" class="float-right mt-2 mb-2 btn btn-primary">Upload
                  Pictures
                </button>
                <button (click)="this.showWebcam()" type="button" class="float-right mr-3 mt-2 mb-2 btn btn-info">Take
                  Picture
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="row justify-content-center" *ngIf="showDocUpload">
                  <div class="col-auto">
                    <ngx-dropzone (change)="onSelect($event)" accept="image/jpeg,image/jpg,image/png"
                                  [maxFileSize]="10000000">
                      <ngx-dropzone-label>Drag N Drop or click to select!</ngx-dropzone-label>
                      <ngx-dropzone-image-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)"
                                                  [file]="f">
                        <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                      </ngx-dropzone-image-preview>
                    </ngx-dropzone>
                  </div>
                </div>
                <remedial-images [images]="remedial?.remedialImages" [showCamera]="showCamera"></remedial-images>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col">
                <button *ngIf="this.canUpdate" (click)="this.submitForm()" type="button"
                        class="float-right mt-2 mb-2 btn btn-primary">Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
